module.exports = __webpack_public_path__ + "img/real-oviedo-logo-icon.ef97e72f.png";